import Fragment from "./fragment";
import FragmentSummary from "./fragment-summary";
import FragmentDataType from "../enums/fragment-data-type";
import { getPeriodSummary } from "../utils/context-utils";

export default class SetTimeAndPeriod extends Fragment {
    constructor(timeAndPeriod) {
        super();

        this.timeAndPeriod = timeAndPeriod; // {period: 1, milliseconds: 72000 }

        this.requiredData = [
            {
                name: "timeAndPeriod",
                type: FragmentDataType.SetTimeAndPeriod,
                displayName: "Time And Period",
                isEditable: true
            }
        ];
    }

    summarize(summaryContext, stringifier) {
        const maxPeriods =
            summaryContext.gameConfig.general.periodsInRegulation;
        const { period: normalizedPeriod, abbreviation } = getPeriodSummary(
            this.timeAndPeriod?.period,
            maxPeriods
        );

        let message = `Time: ${stringifier.milisecondsToMMSS(
            this.timeAndPeriod?.milliseconds
        )} - Period: ${stringifier.ordinalSuffix(
            normalizedPeriod
        )} ${abbreviation}`;

        return new FragmentSummary(message, "Game clock update");
    }

    updateSummaryContext(summaryContext) {
        summaryContext.sopPrinted = true;
        summaryContext.eopPrinted = true;
    }

    getTimeAndPeriod() {
        return this.timeAndPeriod;
    }
}
